export class Media {
    type:any;
    url:any;
    name:any;
    isPlaying:boolean=false
}